import {useEffect} from "react";
import {useNavigate, useSearchParams} from "react-router-dom";

import LoadingIndicator from "components/LoadingIndicator";

import {useGetAppointmentCampaigns} from "liberty-core/api/react-query/appointment";

import {useAuthenticatedUser} from "lib/auth";
import {redirectToParamsPage} from "lib/redirect";
import {useCurrentPharmacy} from "lib/useCurrentPharmacy";

import styles from "./RedirectPage.module.css";

export default function RedirectPage() {
  const [redirectParams] = useSearchParams();
  const [pharmacy] = useCurrentPharmacy();
  const [authenticatedUser, loadingUser] = useAuthenticatedUser();
  const navigate = useNavigate();
  const {data: apptCampaigns, isLoading: isLoadingApptCampaigns} =
    useGetAppointmentCampaigns(pharmacy?.id ?? 0, {enabled: !!pharmacy});

  useEffect(() => {
    if (
      !redirectParams.has("pageName") ||
      (redirectParams.get("pageName") !== "APPOINTMENTS" &&
        redirectParams.get("pageName") !== "CHAT" &&
        redirectParams.get("pageName") !== "INSURANCECARDS" &&
        redirectParams.get("pageName") !== "MEDICATIONS" &&
        redirectParams.get("pageName") !== "REGISTER" &&
        redirectParams.get("pageName") !== "TAXREPORT" &&
        redirectParams.get("pageName") !== "TRANSFERIN")
    ) {
      navigate("/");
    }
  }, [redirectParams, navigate]);

  useEffect(() => {
    const campaignId = redirectParams.get("campaignId");
    const optionId = redirectParams.get("optionId");
    if (!loadingUser && !isLoadingApptCampaigns && pharmacy) {
      if (authenticatedUser) {
        redirectToParamsPage(
          navigate,
          redirectParams,
          authenticatedUser,
          apptCampaigns ?? [],
        );
      } else if (redirectParams.get("pageName") === "APPOINTMENTS") {
        if (!campaignId && !optionId) {
          navigate(`/appointments?${redirectParams.toString()}`);
        } else {
          const apptCampaign = apptCampaigns?.find((c) => c.id === campaignId);
          if (apptCampaign) {
            if (optionId) {
              const hasValidOption = apptCampaign.appointmentOptions?.some(
                (option) => option.id === optionId,
              );
              if (hasValidOption) {
                navigate(
                  `/appointments/guest?campaignId=${campaignId}&optionId=${optionId}&pageName=APPOINTMENTS`,
                  {
                    state: {
                      apptCampaigns: apptCampaigns ?? [],
                    },
                  },
                );
              } else {
                navigate("/appointments", {
                  state: {invalidCampaignOrOptionIds: true},
                });
              }

              return;
            }
            navigate(
              `/appointments/guest?campaignId=${campaignId}&pageName=APPOINTMENTS`,
              {
                state: {
                  apptCampaigns: apptCampaigns ?? [],
                },
              },
            );
            return;
          }
          navigate("/appointments", {
            state: {invalidCampaignOrOptionIds: true},
          });
        }
      } else if (redirectParams.get("pageName") === "REGISTER") {
        navigate(`/register`);
      } else {
        navigate(`/login?${redirectParams.toString()}`);
      }
    }
  }, [
    authenticatedUser,
    loadingUser,
    navigate,
    redirectParams,
    apptCampaigns,
    isLoadingApptCampaigns,
    pharmacy,
  ]);

  return (
    <div className={styles.container}>
      <LoadingIndicator />
    </div>
  );
}
